import { FatalApiError } from './errors';
export function isServerSide() {
    return typeof window === 'undefined';
}
export function getQueryWithoutArrayValues(query) {
    const hasArrayQueryParam = Object.values(query).find((value) => Array.isArray(value));
    if (hasArrayQueryParam) {
        throw new FatalApiError({
            message: 'Array query params not allowed for this route',
            status: 400,
        });
    }
    return query;
}
